/**
 * Lock contador para `document.body` overflow. Permite múltiplos componentes
 * (drawer + dialog) bloquearem scroll simultaneamente sem leakar 'hidden'
 * permanentemente quando o último fechar.
 */
let count = 0;
let prev: string | null = null;

export function lockBody() {
  if (count === 0) {
    prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  count++;
}

export function unlockBody() {
  count = Math.max(0, count - 1);
  if (count === 0) {
    document.body.style.overflow = prev ?? '';
    prev = null;
  }
}
